import { configureStore } from '@reduxjs/toolkit';

import { retailApi } from 'shared/api/retail';
import { onboardingApi } from 'shared/api/onboarding';
import { assignmentPanelReducer } from 'features/assignment-panel';
import { teacherClassesReducer } from 'entities/classes';
import { avatarReducer } from 'widgets/avatar';
import { assignmentServiceApi } from 'shared/api/assignment-service';
import { classStatsApi } from 'shared/api/class-stats';
import { clientStateApi } from 'shared/api/client-state';
import { filtersReducer } from 'features/filters';
import { insightsApi } from 'shared/api/insights';
import { entrywaysApi } from 'shared/api/entryways';
import { aquaApi } from 'shared/api/aqua';
import { walkthroughReducer } from 'features/walkthrough';
import { videoModalReducer } from 'features/video-modal';
import { literacyInsightModalReducer } from 'features/literacy-insight-modal';
import { manageOnboardingInvitesApi } from 'shared/api/manage-onboarding-invites';
import { acceptedInviteAlertReducer } from 'features/accepted-invite-alert';
import { freeToPaidBffApi } from 'shared/api/free-to-paid-bff';
import { recentlyVisitedSvcApi } from 'shared/api/recently-visited-svc';

export const store = configureStore({
  reducer: {
    [retailApi.reducerPath]: retailApi.reducer,
    [entrywaysApi.reducerPath]: entrywaysApi.reducer,
    [aquaApi.reducerPath]: aquaApi.reducer,
    [onboardingApi.reducerPath]: onboardingApi.reducer,
    [assignmentServiceApi.reducerPath]: assignmentServiceApi.reducer,
    [classStatsApi.reducerPath]: classStatsApi.reducer,
    [clientStateApi.reducerPath]: clientStateApi.reducer,
    [insightsApi.reducerPath]: insightsApi.reducer,
    [manageOnboardingInvitesApi.reducerPath]:
      manageOnboardingInvitesApi.reducer,
    [freeToPaidBffApi.reducerPath]: freeToPaidBffApi.reducer,
    [recentlyVisitedSvcApi.reducerPath]: recentlyVisitedSvcApi.reducer,
    teacherClasses: teacherClassesReducer,
    assignmentPanel: assignmentPanelReducer,
    avatar: avatarReducer,
    filters: filtersReducer,
    walkthrough: walkthroughReducer,
    videoModal: videoModalReducer,
    literacyInsightModal: literacyInsightModalReducer,
    acceptedInviteAlert: acceptedInviteAlertReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      retailApi.middleware,
      entrywaysApi.middleware,
      aquaApi.middleware,
      onboardingApi.middleware,
      assignmentServiceApi.middleware,
      classStatsApi.middleware,
      clientStateApi.middleware,
      insightsApi.middleware,
      manageOnboardingInvitesApi.middleware,
      freeToPaidBffApi.middleware,
      recentlyVisitedSvcApi.middleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
